// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ContactPage from "../pages/Contact/Contact";
const __wvcRoutePaths = ["/ContactPage", "/contact"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["accueil", "cadre-juridique-de-la-formation", "certifications-rncp-rs", "contact", "contactpage", "homepage", "legalnoticepage", "mentions-legales", "politique-de-confidentialite", "post", "privacypolicypage", "professionaltrainingqualitypage", "qualite-en-formation-professionnelle", "qui-suis-je", "rncprscertificationspage", "traininglegalframeworkpage", "whoamipage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ContactPage />} />
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ContactPage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
